import { render, staticRenderFns } from "./sTextarea.vue?vue&type=template&id=b1f54556&scoped=true"
import script from "./sTextarea.vue?vue&type=script&lang=js"
export * from "./sTextarea.vue?vue&type=script&lang=js"
import style0 from "./sTextarea.vue?vue&type=style&index=0&id=b1f54556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f54556",
  null
  
)

export default component.exports